import './dot-status_style.css';

const DotStatus: React.FC<
  { status: 'ACTIVE' | 'INACTIVE' | '' } | { status: string }
> = ({ status }) =>
  status ? <span className="dot-status" data-status={status} /> : null;

export default DotStatus;
